export default class ServerResponseError extends Error {
  constructor({ message, code, statusCode, error }) {
    super(message || error);
    this.code = code;
    this.statusCode = statusCode;
  }
}
